<template>
	<div class="InputForm">
		<h1>Submit New Prayer</h1>
		<router-link :to="{name: 'PrayerWall', params: {clientId: $route.params.clientId} }">Go Back</router-link>
		<HBreak />
		<form class="prayerInputForm" @submit.prevent="submitPrayer">
			<div>
				<input placeholder = "Name - Blank for Anonymous" class="singleLineInput" type = "text" v-model="name"/>
			</div>
			<div>
				<textarea placeholder = "Prayer Request - Required" class="prayerRequest" v-model="prayerRequest" @keydown.enter.prevent></textarea>
			</div>
			<div class="checkboxInputWrap">
				<input id="confidentialCheck" type="checkbox" class="checkboxInput" v-model="confidential" /><label class="checkboxInputWrap" for = "confidentialCheck"> - Please make my prayer confidential.<sup>1</sup></label>
			</div>
			<div>
				<div class="g-recaptcha" ref = "captchaWrapper"></div>
			</div>
			<div>
				<button type="submit" :disabled="!safeToSubmit">Submit</button>
			</div>
		</form>

		<HBreak />
		<p>By submitting a prayer request you give permission for it to be shown publicly on the prayer wall.</p>
		<p><sup>1</sup> Prayers marked confidential will only be visible to the account holder and will not be shown publicly on the prayer wall</p>
	</div>
</template>

<script setup>

	import {onMounted, watchEffect, ref, computed} from 'vue'
	import { useStore } from 'vuex'
	import { useRoute, useRouter } from 'vue-router'

	import HBreak from '@/components/HBreak.vue'
	import prayerService from "@/services/prayerService.js"
	import prayerValidate from "/common/validation/prayerContentValidation.js"

	const store = useStore();
	const route = useRoute();
	const router = useRouter();

	let name = ref("");
  	let confidential = ref(false);
  	let prayerRequest = ref("");
  	let captchaComplete = ref(false);
  	let unsafeSubmitOverride = ref(false);

	let captchaWrapper = ref(null);

	onMounted(() =>{
		
		watchEffect(() => {
  		if(store.state.captchaDependenciesLoaded){
			let sitekey = '6LcC1O0cAAAAABb8oW6qH4iVU_xapyZ03ZlnANpG';
			window.grecaptcha.enterprise.render(captchaWrapper.value, {sitekey: sitekey, 
				callback: (token)=>{captchaComplete.value = token},
				"expired-callback": ()=>{captchaComplete.value = false}}
				);
		}
  	})});


	async function submitPrayer(){
  		if(safeToSubmit.value){
  			unsafeSubmitOverride.value = true;
  			try{
  				
		  		await prayerService.submitPrayer({client: route.params.clientId, name: name.value, prayer: prayerRequest.value, captchaToken: captchaComplete.value, isPrivate: confidential.value});
				router.push({name: "PrayerWall", params: {clientId: route.params.clientId}});
		  	}catch(e){
		  		console.log(e);
		  	}
	  		unsafeSubmitOverride.value = false;
	  	}
  	}


	let safeToSubmit = computed(() =>{
		return captchaComplete.value && prayerRequest.value.trim() && !unsafeSubmitOverride.value && prayerValidate(name.value + prayerRequest.value);
	})

</script>

<style scoped>

.InputForm{
	margin-left: auto;
	margin-right: auto;
	max-width: 90vw;
	width: 800px;
}

.prayerInputForm>div{
	margin-top: 20px;
	font-family: 'Roboto Condensed', sans-serif;
	font-size: 2rem;

}

button{
	background-color: #f0fdff;
	border-color: #8f8e8e;
	font-family: 'Roboto Condensed', sans-serif;
	font-size: 2rem;
	color: #8f8e8e;
	padding: 15px;
	cursor: pointer;
}


button:hover{
	color: black;
}

button:disabled{
	opacity: .2;
	color: #8f8e8e;
	cursor: inherit;
}

.prayerInputForm{
	color: #8f8e8e;
	font-size: 13px;
}

.singleLineInput{
	color: #8f8e8e;
	width: 100%;
	font-size: 2rem;
	font-family: 'Roboto Condensed', sans-serif;
	border-left: none;
	border-top: none;
	border-right: none;
	border-bottom-color: #bcbcce;
/*	background-color: #f2f7fb5e;*/
	background: rgb(242,247,251);
	background: linear-gradient(0deg, rgba(242,247,251,0.37) 0%, rgba(242,247,251,0.37) 85%, rgba(242,247,251,0) 100%);

}

.singleLineInput:focus, .singleLineInput:hover{
	color: black;
}

.prayerRequest{
	resize: none;
	font-size: 1.5rem;
	width: 100%;
	height: 200px;
	font-family: 'Roboto Condensed', sans-serif;
	background-color: #f2f7fb5e;
	border-color: #bcbcce;
	color: #8f8e8e;
}

.prayerRequest:focus, .prayerRequest:hover{
	color: black;
}


.checkboxInput{
	transform: scale(2);
	cursor: pointer;
}

.checkboxInputWrap:hover{
	color: black;
	cursor: pointer;
}

.g-recaptcha{
	text-align: center;
	display: flex;
	justify-content: center;
}

</style>